export const dataLikingOffset = 3;
export const domainLiking = [-2, 2];
export const domainKnowledge = [1, 5];
